<template>
  <div class="float-navbar-list">
    <div class="header-setting">
      <div class="header-setting__label">导航列表</div>
    </div>
    <div class="body-setting">
      <div class="body-setting__content">
        <el-collapse v-model="collapse_name" accordion>
          <el-collapse-item v-for="(item, index) in $$FormData.navList" :key="item.id" :name="item.id">
            <template slot="title">
              <image-link-editor
                v-model="item.nav"
                :multiple="false"
                :show-image="false"
                :sort="false"
                @click.stop.native
                @keyup.enter.stop.native
                @keyup.space.stop.native
              />
              <el-button
                type="text"
                size="mini"
                style="color: red; margin-left: 10px;"
                @click.stop="handleRemoveNav(index)"
              >
                删除
              </el-button>
            </template>
            <div class="nav-children">
              <image-link-editor
                v-model="item.children"
                show-image
                show-sub-title
                add-text="添加子导航"
                :limit="10"
              />
            </div>
          </el-collapse-item>
        </el-collapse>
        <el-button type="primary" size="mini" style="margin-top: 10px;" @click="handleAddNav">
          添加
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { uuid } from '@/utils/foundation'

export default {
  name: 'FloatNavbarList',
  data() {
    return {
      collapse_name: ''
    }
  },
  watch: {},
  mounted() {
  },
  methods: {
    handleAddNav() {
      const id = uuid()
      this.$$FormData.navList.push({
        id: id,
        nav: {
          title: '',
          link: null
        },
        children: []
      })
      this.collapse_name = id
    },
    handleRemoveNav(index) {
      this.$confirm('确定要删除这个导航么？', '提示', { type: 'warning' }).then(() => {
        this.$$FormData.navList.splice(index, 1)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.float-navbar-list {
  .body-setting {
    overflow: hidden;
  }
  .body-setting__content {
    background-color: #ffffff;
    padding: 12px;
    ::v-deep .el-collapse-item__header {
      height: auto;
      padding-top: 10px;
      padding-bottom: 10px;
    }
  }
  .nav-children {
    padding: 12px;
  }
}
</style>
